/**
 * Common types, enums, and base types for the Feasibility Analysis System
 */
// ============================================
// ENUMS - Match DB enum naming
// ============================================
export var FeasibilityStudyType;
(function (FeasibilityStudyType) {
    FeasibilityStudyType["COW_CALF"] = "COW_CALF";
    // Future: STOCKER, BACKGROUNDING, FEEDLOT, DAIRY
})(FeasibilityStudyType || (FeasibilityStudyType = {}));
export var FeasibilityStudyStatus;
(function (FeasibilityStudyStatus) {
    FeasibilityStudyStatus["DRAFT"] = "DRAFT";
    FeasibilityStudyStatus["PENDING_CALC"] = "PENDING_CALC";
    FeasibilityStudyStatus["CALCULATED"] = "CALCULATED";
    FeasibilityStudyStatus["ERROR"] = "ERROR";
})(FeasibilityStudyStatus || (FeasibilityStudyStatus = {}));
export var FeasibilityVerdict;
(function (FeasibilityVerdict) {
    FeasibilityVerdict["GO"] = "GO";
    FeasibilityVerdict["CONDITIONAL_GO"] = "CONDITIONAL_GO";
    FeasibilityVerdict["NO_GO"] = "NO_GO";
})(FeasibilityVerdict || (FeasibilityVerdict = {}));
/**
 * Pasture condition classification
 */
export var PastureCondition;
(function (PastureCondition) {
    PastureCondition["EXCELLENT"] = "EXCELLENT";
    PastureCondition["GOOD"] = "GOOD";
    PastureCondition["FAIR"] = "FAIR";
    PastureCondition["POOR"] = "POOR";
})(PastureCondition || (PastureCondition = {}));
/**
 * Water access reliability score
 */
export var WaterReliability;
(function (WaterReliability) {
    WaterReliability["RELIABLE"] = "RELIABLE";
    WaterReliability["MODERATE"] = "MODERATE";
    WaterReliability["UNRELIABLE"] = "UNRELIABLE";
})(WaterReliability || (WaterReliability = {}));
/**
 * Herd ramp-up strategy
 */
export var RampUpStrategy;
(function (RampUpStrategy) {
    RampUpStrategy["PURCHASE"] = "PURCHASE";
    RampUpStrategy["RETAIN"] = "RETAIN";
    RampUpStrategy["HYBRID"] = "HYBRID";
})(RampUpStrategy || (RampUpStrategy = {}));
//# sourceMappingURL=Common.js.map